import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products/identity-security-platform")({
  loader: async () => {
    throw redirect({ to: "/platform-overview" });
  },
});
